import React from 'react'
import { Item, Segment } from 'semantic-ui-react'
import MatchesListItem from './MatchesListItem'



export default ({ matches, socket, onEditClick }) => (
    <Segment.Group>
        {matches.length ?
            matches.map(({ id }, i) => <MatchesListItem key={id} socket={socket} game_id={id} index={i} />) :
            <Item description='Nessuna puntata' style={{ padding: '1em' }} />}
    </Segment.Group>
)


// WEBPACK FOOTER //
// ./src/components/MatchesList.js